// TODO: REVIEW IF ALL ACTION CREATORS ARE USED (esp. GET_AWARD)

import { ACTIVITY_SECTIONS } from 'constants/enums'
import { FETCH_AWARD_SUCCESS, FETCH_AWARD_FAIL, FETCH_AWARD } from './awards'
import mapAwardCategories from 'helpers/mapAwardCategories'
import { isEmpty } from 'lodash'

const COMPLETION = 'dofe-fo/adventurous-journey/COMPLETION'
const COMPLETION_SUCCESS = 'dofe-fo/adventurous-journey/COMPLETION_SUCCESS'
const COMPLETION_FAIL = 'dofe-fo/adventurous-journey/COMPLETION_FAIL'

const CRUD = 'dofe-fo/adventurous-journey/CRUD'
const CRUD_SUCCESS = 'dofe-fo/adventurous-journey/CRUD_SUCCESS'
const CRUD_FAIL = 'dofe-fo/adventurous-journey/CRUD_FAIL'

const SETUP = 'dofe-fo/adventurous-journey/SETUP'
const SETUP_SUCCESS = 'dofe-fo/adventurous-journey/SETUP_SUCCESS'
const SETUP_FAIL = 'dofe-fo/adventurous-journey/SETUP_FAIL'

const APPROVAL = 'dofe-fo/adventurous-journey/APPROVAL '
const APPROVAL_SUCCESS = 'dofe-fo/adventurous-journey/APPROVAL_SUCCESS '
const APPROVAL_FAIL = 'dofe-fo/adventurous-journey/APPROVAL_FAIL '

const GET_AWARD = 'react-template/adventurous-journey/GET_AWARD'
const GET_AWARD_SUCCESS = 'react-template/adventurous-journey/GET_AWARD_SUCCESS'
const GET_AWARD_FAIL = 'react-template/adventurous-journey/GET_AWARD_FAIL'

const GET_CATEGORIES = 'dashboard/adventurous-journey/GET_CATEGORIES'
const GET_CATEGORIES_SUCCESS =
  'dashboard/adventurous-journey/GET_CATEGORIES_SUCCESS'
const GET_CATEGORIES_FAIL = 'dashboard/adventurous-journey/GET_CATEGORIES_FAIL'

const GET_AJ_DETAIL = 'dashboard/adventurous-journey/GET_AJ_DETAIL'
const GET_AJ_DETAIL_SUCCESS =
  'dashboard/adventurous-journey/GET_AJ_DETAIL_SUCCESS'
const GET_AJ_DETAIL_FAIL = 'dashboard/adventurous-journey/GET_AJ_DETAIL_FAIL'

const EDIT_AJ_EVENT = 'dashboard/adventurous-journey/EDIT_AJ_EVENT'
const EDIT_AJ_EVENT_SUCCESS =
  'dashboard/adventurous-journey/EDIT_AJ_EVENT_SUCCESS'
const EDIT_AJ_EVENT_FAIL = 'dashboard/adventurous-journey/EDIT_AJ_EVENT_FAIL'

const EDIT_AJ_AIM = 'dashboard/adventurous-journey/EDIT_AJ_AIM'
const EDIT_AJ_AIM_SUCCESS = 'dashboard/adventurous-journey/EDIT_AJ_AIM_SUCCESS'
const EDIT_AJ_AIM_FAIL = 'dashboard/adventurous-journey/EDIT_AJ_AIM_FAIL'

const GET_PT_SIGNOFF = 'dashboard/adventurous-journey/GET_PT_SIGNOFF'
const GET_PT_SIGNOFF_SUCCESS =
  'dashboard/adventurous-journey/GET_PT_SIGNOFF_SUCCESS'
const GET_PT_SIGNOFF_FAIL = 'dashboard/adventurous-journey/GET_PT_SIGNOFF_FAIL'

const GET_AJ_FILES = 'dashboard/adventurous-journey/GET_AJ_FILES'
const GET_AJ_FILES_SUCCESS =
  'dashboard/adventurous-journey/GET_AJ_FILES_SUCCESS'
const GET_AJ_FILES_FAIL = 'dashboard/adventurous-journey/GET_AJ_FILES_FAIL'

const initialState = {
  completion: {
    loading: false,
    loaded: false
  },
  setup: {
    loading: false,
    loaded: false
  },
  approval: {
    loading: false,
    loaded: false
  },
  loaded: false,
  data: null,
  signoffPT: {},
  filesLoading: false,
  ajFiles: []
}

export default function adventurousJourney(state = initialState, action = {}) {
  switch (action.type) {
    case COMPLETION:
      return {
        ...state,
        completion: {
          ...state.completion,
          loading: true
        }
      }

    case COMPLETION_SUCCESS:
      return {
        ...state,
        completion: {
          ...state.completion,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case COMPLETION_FAIL:
      return {
        ...state,
        completion: {
          ...state.completion,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case SETUP:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: true
        }
      }

    case SETUP_SUCCESS:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case SETUP_FAIL:
      return {
        ...state,
        setup: {
          ...state.setup,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case APPROVAL:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: true
        }
      }

    case APPROVAL_SUCCESS:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: false,
          loaded: true,
          error: null
        }
      }

    case APPROVAL_FAIL:
      return {
        ...state,
        approval: {
          ...state.approval,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case FETCH_AWARD:
    case GET_AWARD:
      return {
        ...state,
        loading: true
      }

    case FETCH_AWARD_SUCCESS:
    case GET_AWARD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        data: action.result
      }

    case FETCH_AWARD_FAIL:
    case GET_AWARD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    case GET_CATEGORIES:
      return {
        ...state,
        loading: true
      }

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        categories: !isEmpty(action.result)
          ? mapAwardCategories(action.result)
          : []
      }

    case GET_CATEGORIES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    case GET_AJ_DETAIL:
      return {
        ...state,
        loading: true
      }

    case GET_AJ_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        detail: action.result
      }

    case GET_AJ_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }

    case GET_PT_SIGNOFF:
      return {
        ...state,
        loading: true
      }

    case GET_PT_SIGNOFF_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        signoffPT: action.result
      }

    case GET_PT_SIGNOFF_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_AJ_FILES:
      return {
        ...state,
        filesLoading: true
      }

    case GET_AJ_FILES_SUCCESS:
      return {
        ...state,
        filesLoading: false,
        ajFiles: action.result
      }

    case GET_AJ_FILES_FAIL:
      return {
        ...state,
        filesLoading: false,
        error: action.error
      }

    default:
      return state
  }
}

export function isLoaded(globalState) {
  return globalState.adventurousJourney && globalState.adventurousJourney.loaded
}

export function getAwardDetail(awardId) {
  const params = {
    with: 'with=ADVENTUROUS_JOURNEYS,AJ_PREP_TRAINING,AWARD_LEVEL,ASSESSOR_REGISTRATION_DATA'
  }

  return {
    types: [GET_AWARD, GET_AWARD_SUCCESS, GET_AWARD_FAIL],
    promise: client => client.get(`api/awards/${awardId}?${params.with}`)
  }
}

export function editAjEventDetail(ajId, data) {
  return {
    types: [EDIT_AJ_EVENT, EDIT_AJ_EVENT_SUCCESS, EDIT_AJ_EVENT_FAIL],
    promise: client =>
      client.post(`api/aj-events/${ajId}/edit`, {
        data
      })
  }
}

export function editAjEventAim(ajId, data) {
  return {
    types: [EDIT_AJ_AIM, EDIT_AJ_AIM_SUCCESS, EDIT_AJ_AIM_FAIL],
    promise: client =>
      client.post(`api/aj-participant-events/${ajId}/edit-aim`, {
        data
      })
  }
}

export function getAJCategories(awardLevel) {
  const params = {
    filter: `filter=activitySection.value=${ACTIVITY_SECTIONS.adventurous_journey.id},isActive=true`
  }

  return {
    types: [GET_CATEGORIES, GET_CATEGORIES_SUCCESS, GET_CATEGORIES_FAIL],
    promise: client =>
      client.get(
        `api/activity-categories?${params.filter}&awardLevel=${awardLevel}&firstRow=0&maxRows=0&getTotalRowCount=false`
      )
  }
}

export function setupParticipantEventJourney(data) {
  return {
    types: [SETUP, SETUP_SUCCESS, SETUP_FAIL],
    promise: client => client.post('api/aj-participant-events/setup', { data })
  }
}

export function completeAJParticipantEvent(aJId, data) {
  return {
    types: [COMPLETION, COMPLETION_SUCCESS, COMPLETION_FAIL],
    promise: client =>
      client.post(`api/aj-participant-events/${aJId}/completions`, { data })
  }
}

export function editAJTraining(awardId, data) {
  return {
    types: [SETUP, SETUP_SUCCESS, SETUP_FAIL],
    promise: client =>
      client.post(`api/awards/${awardId}/aj-preparation-trainings`, { data })
  }
}

export function signOffRequestPT(awardId) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(
        `api/awards/${awardId}/aj-preparation-trainings/award-leader-signoff-requests?`,
        { data: {} }
      )
  }
}

export function getPTSignoff(awardId, actionId) {
  return {
    types: [GET_PT_SIGNOFF, GET_PT_SIGNOFF_SUCCESS, GET_PT_SIGNOFF_FAIL],
    promise: client =>
      client.get(
        `api/awards/${awardId}/aj-preparation-trainings/sign-offs/${actionId}`,
        { data: {} }
      )
  }
}

export function assessorRequestPE(aJId, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(`api/aj-participant-events/${aJId}/assessment-requests`, {
        data
      })
  }
}

export function assessorLeaderPE(aJId, data) {
  return {
    types: [APPROVAL, APPROVAL_SUCCESS, APPROVAL_FAIL],
    promise: client =>
      client.post(
        `api/aj-participant-events/${aJId}/award-leader-signoff-requests`,
        { data }
      )
  }
}

export function getAJDetail(aJId) {
  const params = {
    with: 'with=AJ_EVENT'
  }

  return {
    types: [GET_AJ_DETAIL, GET_AJ_DETAIL_SUCCESS, GET_AJ_DETAIL_FAIL],
    promise: client =>
      client.get(`api/aj-participant-events/${aJId}?${params.with}`)
  }
}

export function getAJfiles(awardId) {
  return {
    types: [GET_AJ_FILES, GET_AJ_FILES_SUCCESS, GET_AJ_FILES_FAIL],
    promise: client => client.get(`api/aj-events/${awardId}/award-files`)
  }
}

export function ajEventAssessorRejection(ajEventId, data) {
  return {
    types: [CRUD, CRUD_SUCCESS, CRUD_FAIL],
    promise: client =>
      client.post(`api/aj-events/${ajEventId}/assessor-rejection`, { data })
  }
}
